import { combineReducers } from 'redux';

import byId from './byId';
import allCashIds from './allCashIds';
import allDepositIds from './allDepositIds';

export const filterAssets = (assets, type) => {
  const allIds = Object.keys(assets)
  const filteredList = []

  allIds.forEach((id) => {
    if( assets[id].assetType == type) {
      filteredList[id] = assets[id]
    }
  })

  return filteredList
}

export const getCashAssetIds = (state) => state.allCashIds;
export const getDepositAssetIds = (state) => state.allDepositIds;
export const getAsset = (state, id) => state.byId[id];
export const getAssets = (state) => state.byId

export default combineReducers({
  byId,
  allCashIds,
  allDepositIds,
});
